import queryString from 'query-string'

const VIS_MANAGER_TYPE = 'vismgr'

export function isVisManager() {
  const queryParams = queryString.parse(location.hash.split('?')[1])
  return queryParams.visit_type === VIS_MANAGER_TYPE
}

export function getApiKey() {
  const queryParams = queryString.parse(location.hash.split('?')[1])
  return queryParams.api_key
}

export function notifyVisManager(notificationName) {
  if (window.external && window.external[notificationName] && typeof window.external[notificationName] === 'function') {
    console.log(`Notifying VisManager. Calling window.external.${notificationName}...`)
    window.external[notificationName]()
  }
}
